<template>
  <!-- 库存报警 -->
  <div>
    <!-- 搜索 -->
    <div>
      <el-form
        :inline="true"
        ref="rulesNoeForm"
        :model="formInline"
        class="demo-form-inline"
      >
        <el-row>
          <el-col :span="6">
            <el-form-item label="商品名" size="medium " prop="amountPayable">
              <el-input
                v-model="formInline.amountPayable"
                placeholder="商品名"
                style="width: 250px"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-button
            type="primary"
            icon="el-icon-search"
            style="margin-left: 10px"
            size="mini"
            @click="onSearch"
            >搜索
          </el-button>
        </el-row>
      </el-form>
    </div>
    <!-- 表格 -->
    <div>
      <el-table
        ref="multipleTable"
        :data="tableData"
        border
        tooltip-effect="dark"
        style="width: 100%"
        height="calc(100vh - 264px)"
        @row-dblclick="updateRecordView"
      >
        <el-table-column type="index" label="编号" width="50"></el-table-column>
        <el-table-column
          prop="goodsCode"
          label="商品名称"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="goodsName"
          label="商品型号"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="goodsModel"
          label="商品类别"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="goodsTypeDesc"
          label="单位"
          align="center"
          width="130"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="goodsTypeDesc"
          label="采购价"
          align="center"
          width="130"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="goodsTypeDesc"
          label="销售价"
          align="center"
          width="130"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="goodsTypeDesc"
          label="当前库存"
          align="center"
          width="130"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="goodsTypeDesc"
          label="库存下线"
          align="center"
          width="130"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="inventoryMin"
          label="生产厂家"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <!-- <el-table-column align="center" prop="cz" label="操作" width="100px">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="light" content="订单详情" placement="top">
              <el-button
                style="float: none; padding: 3px 0; color: #ff0000"
                type="text"
                icon="el-icon-s-order"
                @click="goRedact(scope, tableData)"
              ></el-button>
            </el-tooltip>

            <el-tooltip class="item" effect="light" content="删除该数据" placement="top">
              <el-button
                v-if="scope.row.goodsState == null || scope.row.goodsState == 0"
                style="float: none; padding: 3px 0; color: #ff0000"
                type="text"
                icon="el-icon-delete"
                @click="deleteRow(scope.row)"
              ></el-button>
            </el-tooltip>
          </template>
        </el-table-column> -->
      </el-table>
      <div style="display: flex; justify-content: flex-end; margin-top: 5px">
        <el-pagination
          background
          @current-change="currentChange"
          @size-change="sizeChange"
          :page-sizes="[10, 20, 50, 100, 1000]"
          layout="sizes, prev, pager, next, jumper, ->, total"
          :total="total"
          :current-page="page">
        </el-pagination>
      </div>
    </div>
    <!-- 弹出框 -->
    <el-dialog
      :title="titleType"
      width="70%"
      :visible.sync="dialogFormVisible"
      :before-close="handleClose"
    >
      <el-card class="box-card">
        <el-form
          :model="ruleForm"
          ref="ruleForm"
          label-width="100px"
          class="demo-form-inline"
          label-position="right"
        >
          <el-row>
            <el-col :span="8">
              <el-form-item label="进货单号" prop="goodsName">
                <el-input v-model="ruleForm.goodsName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="供应商" prop="goodsModel">
                <el-input v-model="ruleForm.goodsModel"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="进货金额" prop="goodsType">
                <el-input v-model="ruleForm.goodsModel"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="支付状态" prop="goodsUnit">
                <el-input v-model="ruleForm.goodsModel"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="操作员" prop="inventoryMin">
                <el-input v-model="ruleForm.inventoryMin"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-table
          :data="formInline.goodsJson"
          border
          style="width: 100%"
          height="calc(60vh - 70px)"
        >
          <el-table-column prop="goodsCode" align="center" label="商品编码">
          </el-table-column>
          <el-table-column prop="goodsName" align="center" label="商品名称">
          </el-table-column>
          <el-table-column prop="goodsModel" align="center" label="商品型号">
          </el-table-column>
          <el-table-column prop="unitPrice" align="center" label="单价" width="180">
          </el-table-column>
          <el-table-column prop="goodsNumber" align="center" label="数量" width="100">
          </el-table-column>
          <el-table-column prop="goodsUnit" align="center" label="单位" width="100">
          </el-table-column>
          <el-table-column prop="address" align="center" label="总金额" width="180">
            <template slot-scope="scope">
              {{ scope.row.goodsNumber * scope.row.unitPrice }}
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <div slot="footer" class="dialog-footer" v-if="flag">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm', 'add')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  dictionaries,
  postCitys,
  goodsList,
  addGoods,
  deleteGoods,
  querySupplier,
  updateGoods,
} from "../../../api/SlmsData/Merchandise";
export default {
  data() {
    // 在 Input 值改变时触发
    return {
      formInline: {
        name: "",
        amountPayable: "",
        actualPayment: "",
        value1: "",
        remarks: "",
        region: "",
        goodsJson: [],
      },
      ruleForm: {
        goodsName: "",
        goodsModel: "",
        goodsType: "",
        goodsCode: "",
        goodsUnit: "",
        inventoryMin: "",
        currentInventory: "",
        unitPrice: "",
        goodsNumber: "",
      },

      goodsName: "", //供应商名称
      dialogFormVisible: false,
      tableData: [],
      requestApi: true, //true新增,false修改
      flag: true,
      categoryType: [],
      procedureType: [],
      titleType: "",
      total: 0,
      multipleSelection: [],
      page: 1, //页码
      limit: 10, //1页记录数
    };
  },
  created() {
    this.searchType();
    this.searchButton();
  },
  mounted() {},
  methods: {
    //查询字典表
    async searchType() {
      let resA = await dictionaries("goods_type"); //货品类别
      this.categoryType = resA.result;
      let resB = await dictionaries("goods_unit"); //商品单位
      this.procedureType = resB.result;
    },
    //头部商品查询 dictionaries
    // 搜索/筛选入口：先回到第 1 页再查（避免在第 N 页搜索时结果不足一页而显示空白）
    onSearch() {
      this.page = 1;
      this.searchButton();
    },

    async searchButton() {
      let res = await goodsList(this.page, this.limit, this.goodsName);
      this.tableData = res.data;
      this.total = res.count;
    },
    //新增商品信息
    handleAdd() {
      this.titleType = "新增商品信息";
      this.dialogFormVisible = true;
    },
    //双击表格打开弹窗
    async updateRecordView(scope) {
      this.titleType = "进货单商品信息";
      this.ruleForm = scope;
      this.dialogFormVisible = true;
      this.flag = false;
    },
    //提交新增商品信息
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (!valid) {
          this.$notify({
            title: "操作失败",
            dangerouslyUseHTMLString: true,
            message: "请填写完整",
            type: "warning",
          });
          return;
        }
        let resData = {};
        try {
          if (this.requestApi) {
            resData = await addGoods(this.ruleForm);
            this.$refs["ruleForm"].resetFields();
          } else {
            // let {
            //   goodsName,
            //   goodsModel,
            //   goodsType,
            //   goodsUnit,
            //   inventoryMin,
            //   manufacturer,
            //   remarks,
            // } = this.ruleForm;
            // let res = {
            //   goodsName:goodsName,
            //   goodsModel: goodsModel,
            //   goodsType: goodsType,
            //   goodsUnit: goodsUnit,
            //   inventoryMin: inventoryMin,
            //   manufacturer: manufacturer,
            //   remarks: remarks,
            // };
            resData = await updateGoods(this.ruleForm);
          }
        } catch (e) {
          console.error("接口异常");
        }
        this.searchButton();
        this.$notify({
          title: resData ? "成功" : "失败",
          dangerouslyUseHTMLString: true,
          message: resData ? resData.message : "服务器开小差了，请稍后再试",
          type: resData ? "success" : "warning",
        });
      });
    },
    //关闭弹窗前回调
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
          this.ruleForm = {};
          this.flag = true;
          this.requestApi = true; //true新增,false修改
        })
        .catch((_) => {});
    },
    //编辑客户信息
    async goRedact(scope) {
      this.titleType = "进货单商品信息";
      this.ruleForm = scope.row;
      //处理多余数据
      this.dialogFormVisible = true;
      this.requestApi = false;
      this.flag = true;
    },
    //删除单个
    deleteRow(row) {
      this.$confirm("确定删除吗?", "删除", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let R = await deleteGoods({ id: row.id });
          this.searchButton();
        })
        .catch((err) => {
          console.error(err);
        });
    },

    // // 全选
    // handleSelectionChange(val) {
    //   this.multipleSelection = val;
    // },
    //分页
    currentChange(currentPage) {
      this.page = currentPage;
      this.searchButton();
    },
    sizeChange(limit) {
      this.page = 1; // 改每页条数：回到第 1 页
      this.limit = limit;
      this.searchButton();
    },
  },
};
</script>

<style lang="scss" scoped>
.handle_box {
  margin: 1vh 0;
}
::v-deep .el-form-item {
  margin-bottom: 8px;
}
::v-deep .el-dialog__body {
  padding: 0 20px;
}
::v-deep .el-tabs--border-card > .el-tabs__content {
  padding: 14px 15px;
}
</style>
